var map = {
	"./basketball-active.webp": 1512,
	"./basketball.webp": 1513,
	"./bg.webp": 1514,
	"./football-active.webp": 1515,
	"./football.webp": 1516,
	"./games-active.webp": 1517,
	"./games.webp": 1518,
	"./live-streaming-cover.webp": 1519,
	"./lv-active-bg.webp": 1520,
	"./video-bg.webp": 1521,
	"./video-icon.webp": 1522,
	"./vs.webp": 1523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;